import { sdk } from '../../config'
import {
  CreatePrintActionHistoryRecordRequest,
  GetPrintActionHistoryForRepairOrderRequest,
  PrintActionEntry
} from '../../sdk'
import { api } from './'

const createPrintActionHistoryRecord =
  sdk.createPrintActionHistoryRecord.bind(sdk)
const getPrintActionHistoryForRepairOrder =
  sdk.getPrintActionHistoryForRepairOrder.bind(sdk)

const printableApi = api.injectEndpoints({
  endpoints: (builder) => ({
    createPrintActionHistoryRecord: builder.mutation<
      void,
      CreatePrintActionHistoryRecordRequest
    >({
      query: (req) => () => createPrintActionHistoryRecord(req),
      invalidatesTags: (res, err, req) => [
        {
          type: 'PrintAction',
          id: `Repair Order: ${req.printActionInfo!.repairOrderId}`
        },
        'PrintAction'
      ]
    }),
    getPrintActionHistoryForRepairOrder: builder.query<
      Array<PrintActionEntry>,
      GetPrintActionHistoryForRepairOrderRequest
    >({
      query: (req) => () => getPrintActionHistoryForRepairOrder(req),
      providesTags: (res, error, req) => [
        ...(res
          ? res.map(({ id }) => ({ type: 'PrintAction' as const, id }))
          : []),
        {
          type: 'PrintAction' as const,
          id: `Repair Order: ${req.repairOrder}`
        },
        'PrintAction'
      ]
    })
  })
})

export const {
  useGetPrintActionHistoryForRepairOrderQuery,
  useCreatePrintActionHistoryRecordMutation
} = printableApi
